
// export const myGetter = ( state ) => {
//  return state
// }

export const typeproductsList = state => state.typeproducts
export const typeproductsSelectable = state => state.typeproductsSelectable
export const typeproductsPaginatedData = state => state.typeproductsPaginatedData
export const typeproduct = state => state.typeproduct
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData